import { render, staticRenderFns } from "./Boxselection.vue?vue&type=template&id=0381dd64&scoped=true&"
import script from "./Boxselection.vue?vue&type=script&lang=js&"
export * from "./Boxselection.vue?vue&type=script&lang=js&"
import style0 from "./Boxselection.vue?vue&type=style&index=0&id=0381dd64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381dd64",
  null
  
)

export default component.exports